export default "__VITE_ASSET__vVDVfZl1__"